//login.js
import request from '@/utils/request';

export function login(data) {
  return request({
    url: '/v1/user_info/login',
    method: 'post',
    data: data,
  });
}
